import { render, staticRenderFns } from "./SaleTotals.vue?vue&type=template&id=92d25390&lang=pug&"
import script from "./SaleTotals.vue?vue&type=script&lang=js&"
export * from "./SaleTotals.vue?vue&type=script&lang=js&"
import style0 from "./SaleTotals.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SaleTotals.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VAvatar,
  VCard,
  VChip,
  VDivider,
  VFlex,
  VLayout,
})
